import script from "./PurchaseDailyReport.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseDailyReport.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseDailyReport.vue?vue&type=style&index=0&id=4fcf5459&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fcf5459"]])

export default __exports__